import { OverlayState } from '@/store/overlays/types';

export default <OverlayState>{
    overlaysActive: 0,
    accountSwitcherPanelOpen: false,
    pendingObserver: null,
};
